import { GridCellDefaultRendererWebComponent } from './component/GridCellDefaultRendererWebComponent';
import { WEB_COMPONENT_GRID_CELL_DEFAULT_RENDERER } from '../../../webcomponents.constants';

export { GridCellDefaultRendererWebComponent };

if (!window.customElements.get(WEB_COMPONENT_GRID_CELL_DEFAULT_RENDERER)) {
  window.customElements.define(WEB_COMPONENT_GRID_CELL_DEFAULT_RENDERER, GridCellDefaultRendererWebComponent);
}
